<template>
    <v-row>
        <v-form
            ref="form"
            >
                <v-col cols="12">
                    <v-text-field
                        v-model="form.code"
                        outlined
                        dense
                        clearable
                        hide-details="auto"
                        label="Code">
                    </v-text-field>
                </v-col>
                <v-col cols="12">
                    <PDatePicker
                        v-model="form.from"
                        outlined
                        dense
                        hide
                        clearable
                        label="From">
                    </PDatePicker>
                </v-col>

                <v-col cols="12">
                    <PDatePicker
                        v-model="form.to"
                        outlined
                        dense
                        hide
                        clearable
                        label="To">
                    </PDatePicker>
                </v-col>

                <v-col cols="12">
                    <v-select
                        outlined
                        dense
                        hide-details="auto"
                        v-model="form.state_code"
                        clearable
                        label="State"
                        :items="states"
                        item-text="text"
                        item-value="value">
                    </v-select>
                </v-col>
        </v-form>
    </v-row>
</template>

<script>
import 
PDatePicker from "./../../components/common/PDatePicker"
import { mapActions, mapGetters } from 'vuex';
import requisition from './../../services/purchase/requisition'

export default {
    name: "PurchaseRequisitionListSearch",
    components: {
        PDatePicker
    },
    data() {
        return {
            form: {
                code: null,
                from: null,
                to: null,
                state_code: 1,
            },
            states: []
        }
    },
    computed: {
        ...mapGetters({
            params: "purchase/requisition/params",
        })
    },
    methods: {
        ...mapActions({
            updateParams: "purchase/requisition/updateParams",
        }),
        submit() {
            this.updateParams(this.form);
        }
    },
    created() {
        this.form = {...this.params}
        requisition.getStates().then(response => this.states = response.data);
    }
    
}
</script>

<style>

</style>